import {
  AlertTriangle,
  BadgeCheck,
  Ban,
  CheckCircle2,
  Clock,
  Cookie,
  Copyright,
  CreditCard,
  Database,
  Eye,
  FileText,
  Gift,
  Heart,
  HelpCircle,
  Info,
  ListOrdered,
  Lock,
  Mail,
  MapPin,
  MessageCircle,
  Package,
  Phone,
  RefreshCw,
  Scale,
  Share2,
  ShieldCheck,
  ShoppingBag,
  Sparkles,
  Star,
  Tag,
  Target,
  Truck,
  UserCheck,
  UserCog,
  Wallet,
  XCircle,
} from 'lucide-react';

/** الأيقونات المتاحة لأقسام الصفحات (بنخزّن الاسم في قاعدة البيانات) */
export const PAGE_ICONS = {
  FileText,
  ShieldCheck,
  RefreshCw,
  HelpCircle,
  Info,
  CheckCircle2,
  XCircle,
  AlertTriangle,
  BadgeCheck,
  ListOrdered,
  Eye,
  Truck,
  Package,
  ShoppingBag,
  Wallet,
  CreditCard,
  Tag,
  Gift,
  MessageCircle,
  Phone,
  Mail,
  MapPin,
  Clock,
  Database,
  Target,
  Share2,
  Lock,
  Cookie,
  UserCheck,
  UserCog,
  Copyright,
  Ban,
  Scale,
  Star,
  Heart,
  Sparkles,
};

export const pageIcon = (name) => PAGE_ICONS[name] || null;
